import { createTheme } from '@mui/material';

export const LightTheme = createTheme({
    palette: {
        primary: {
            // Identidade HidroBR (public/logo_hidro.png): azul petróleo
            main: '#005979',
            dark: '#004B6A',
            contrastText: '#000000',
        },
        secondary: {
            main: '#FFFFFF',
            contrastText: '#000000',
        },
        background: {
            default: '#F4F8F9',
            paper: '#FFFFFF',
        },
    },
    typography: {
				fontFamily: 'Roboto',
        allVariants: {
            color: 'black'
        }
    },
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: '10px',
                },
            },
        },
        MuiAccordion: {
            defaultProps: {
                square: true,
                disableGutters: true,
            },
            styleOverrides: {
                root: {
                    borderRadius: '30px',
                },
            },
        },
        MuiButton: {
        styleOverrides: {
            root: {
                borderRadius: '25px',
                // color: 'white'
            },
            // contrastText segue preto (convenção de foreground do modo claro); botão preenchido precisa de texto branco sobre o azul
            containedPrimary: {
                color: '#FFFFFF',
            },
        }
        },
    }
});

